
<template>
    <div class="p-d-flex p-jc-center">
        <Button :label="textLabelHistorico" 
        class="p-mt-3 p-mr-2" :class="exibirSpin ? 'p-button-secondary' : 'p-button-warning'" 
        :icon="exibirSpin ? 'pi pi-spin pi-spinner' : 'pi pi-folder'"
        @click="irParaHistorico" v-if="exibirBtnHistoricoRelatorio"/>
        <Button :label="textoLabelProcessandoAFD" 
            class="p-button-secondary p-ml-2" 
            icon="pi pi-spin pi-spinner" 
            @click="irParaHistoricoDocumentos" 
            v-if="exibirBtnMonitorandoAFD"/> 
    </div>
    
</template>
  
<script>
import RelatorioService from '@/service/RelatorioService';
import { exibirMensagem, exibirMensagemSis, preViewUrlArquivo, abrirArquivoComDefault } from '@/global';
import { mapGetters } from 'vuex';

export default {
props: {
        callback: {
            type: Function,
            required: false,
        }
    },
    relatorioService: null,
    data() {
        return {       
            textoLabelProcessandoAFD: '',
            textLabelHistorico: 'Histórico de Relatórios/Documentos',
            pararTimeout: false,       
            exibirSpin: false,
            exibirBtnHistoricoRelatorio: false,
            exibirBtnMonitorandoAFD: false,
            quantidadesTentativas: 0,    
            documento: null,     
            maxTimeout: 5000
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),     
        /**
         *  
         */
        iniciarMonitoramento(documento) {   
            this.reset();  
            this.documento = documento;               
            this.exibirBtnHistoricoRelatorio = true;
            this.exibirSpin = true;
            this.textLabelHistorico = 'Processando o arquivo. Acesse o Histórico de Relatórios/Documentos';
            setTimeout(() => {
                this.buscarArquivo(documento);
            }, this.maxTimeout);
        },
        /**
         * 
         */
        iniciarMonitoramentoAFD(documento) {   
            this.reset();  
            this.documento = documento;               
            this.exibirBtnMonitorandoAFD = true;           
            this.textoLabelProcessandoAFD = 'Processando o arquivo/dados do ponto. Acesse o Histórico de Relatórios/Documentos';
            setTimeout(() => {
                this.buscarSolicitacaoAFD(documento);
            }, 15000);
        },
        /**
         * 
         */
        buscarArquivo(documento) {                       
            if(this.pararTimeout) {
                return;
            }             
            this.relatorioService.buscarSolicitacao(documento.id)
            .then(resp => {
                this.documento = resp.data;
                this.documento['id'] = documento.id;
                this.validarArquivo(resp.data);                              
            })
            .catch(erro => {               
                this.finalizar();
                exibirMensagem(this, erro);
            });
        },
        /**
         * 
         */
        validarArquivo(documento) {
            if(documento.status == 'FILA' || documento.status == 'PROCESSANDO') {
                if(this.quantidadesTentativas < 10) {  
                    this.quantidadesTentativas++;  
                    setTimeout(() => {
                        this.buscarArquivo(documento);                       
                    }, this.maxTimeout);
                } else {                   
                    this.finalizar();
                    this.exibirBtnHistoricoRelatorio = true;
                    this.textLabelHistorico = 'O arquivo foi para fila de processamento. Acesse o Histórico de Relatórios/Documentos para acompanhar o status';                    
                }
                return;					
            }
            this.finalizar(); 
            if(documento.status == 'PROCESSADO' && documento.link) {
                if(documento.nomeArquivo.includes('.pdf')) {
                    preViewUrlArquivo(documento.link);
                } else {
                    abrirArquivoComDefault(documento.link);
                }
            } else {
                let dados = documento.mensagem.split('#');  
                exibirMensagemSis(this, dados[1], true);
            }
        },
        /**
         * 
         */
        buscarSolicitacaoAFD(soliticacao) {
            if(this.pararTimeout) {
                return;
            }             
            this.relatorioService.buscarSolicitacao(soliticacao.id)
            .then(resp => {
                this.documento = resp.data;
                if(this.documento.status == 'FILA' || this.documento.status == 'PROCESSANDO') {
                    setTimeout(() => {
                        this.buscarSolicitacaoAFD(soliticacao);
                    }, 15000);
                } else if(this.documento.status == 'ERRO') {     
                    let mensagemErro = this.documento.mensagem.split('#')[1];                    
                    exibirMensagemSis(this, mensagemErro, true); 
                    this.finalizar();
                } else {
                    exibirMensagemSis(this, 'Sucesso! Arquivo e dados processados.', true);             
                    this.finalizar();                    
                }             
            })
            .catch(erro => {
                this.finalizar();
                exibirMensagem(this, erro);
            });
        },
        /**
         * 
         */
        irParaHistorico() {            
            let temp = 'temp_hist_1_'  + Date.now();
            sessionStorage.setItem('tem_historico_relatorio',  temp);			
            this.$router.push({ path: '/relatorios?hist=' + temp + '&id=' + this.documento.id }); 
        }, 
        /**
         * 
         */
        irParaHistoricoDocumentos() {            
            let temp = 'temp_hist_1_'  + Date.now();
            sessionStorage.setItem('tem_historico_documento',  temp);			
            this.$router.push({ path: '/documentos?hist=' + temp + '&id=' + this.documento.id }); 
        },        
        /**
         * 
         */
        reset() { 
            this.textLabelHistorico = 'Histórico de Relatórios/Documentos';        
            this.exibirSpin = false;
            this.exibirBtnHistoricoRelatorio = false;
            this.exibirBtnMonitorandoAFD = false;
            this.quantidadesTentativas = 0;
        },
        /**
         * 
         */
        finalizar() {
            this.reset();
            if(this.callback) {
                this.callback();
            }
        }
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    beforeDestroy() {
        this.pararTimeout = true;  
    }
}
</script>

<style>

</style>